<script>
import { mapState, mapMutations } from "vuex";
import SelectionForm from "@/components/ContractModals/Components/BaseParts/SelectionForm";

export default {
  extends: SelectionForm,
  computed: {
    ...mapState("QuotationContractModal", ["requestedServices"])
  },
  methods: {
    ...mapMutations("QuotationContractModal", [
      "addSelectedCondition",
      "delSelectedCondition",
      "setCurrentSelectedCondition",
      "setLabourQuantity",
      "setUnitsOne",
      "setHourlyPrice",
      "setUnitsTwo"
    ])
  }
};
</script>
